import { Grid } from "@mui/material";
import { AutoComplete } from "@poseidon/ui/components/AutoComplete";
import { FullWidthField } from "@poseidon/ui/components/form/FullWidthField";
import { Panel } from "@poseidon/ui/components/Panel";
import { Field, useFormikContext } from "formik";
import { useBoatOptions } from "./BoatOptionsContext";

export function BasicDetailFields({ asDealer }) {
  const options = useBoatOptions();
  const { setFieldValue } = useFormikContext();
  return (
    <Panel title="Basic Details">
      <Grid container spacing={2} mt={0}>
        <Grid item xs={12} sm={6}>
          <Field
            component={FullWidthField}
            name="hin"
            label="Hull Identification Number"
            margin="none"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          {asDealer ? (
            <Field
              disabled={asDealer}
              component={FullWidthField}
              name="type"
              label="Type"
              margin="none"
            />
          ) : (
            <AutoComplete
              loading={options.loading}
              name="type"
              label="Type"
              margin="none"
              options={options.types}
              onChange={() => {
                setFieldValue("make", "");
                setFieldValue("model", "");
              }}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            disabled={asDealer}
            component={FullWidthField}
            name="make"
            label="Make"
            margin="none"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            disabled={asDealer}
            component={FullWidthField}
            name="model"
            label="Model"
            margin="none"
          />
        </Grid>
        {!asDealer && (
          <Grid item xs={12} sm={6}>
            <Field
              component={FullWidthField}
              name="homeMarina"
              label="Home Marina"
              margin="none"
            />
          </Grid>
        )}
      </Grid>
    </Panel>
  );
}
